import { Link } from "@mui/material";

import {
  faqs,
  howItWorks,
  BucksCheckoutTerms,
  BucksRegistrationTerms,
} from "../milwaukeebucks_flex/helpers";
import { routes } from "@/global/routes";
import { inventoryTypeUIDs, vendorUUIDs } from "../../constants";

import SeatMap3dPreview from "public/images/milwaukeebucks/bucks-preview.jpg";
import FindGamesBanner from "public/images/milwaukeebucks/2025-26_PartialPlans_10-Game-FlexPlans_SiteBuildGraphics_ATTEND_BannerHeaderImage_1486x128.png";

const LogoImage =
  "https://ss-leagues.s3.amazonaws.com/NBA%202025/Milwaukee_Bucks_logo.png";

import type { TeamConfig } from "../types";

const config: TeamConfig = {
  teamSchema: "sandbox_accountrep",
  browserTitle: "Bucks 2025-26 Flex Plan",
  packages: false,
  defaultRoute: routes.purchaseSeats,
  phoneNumber: "",
  teamName: "Flex Sandbox",

  // seat map configs
  seatMapConfigs: {
    mapId: "blockmap2d",
    venueId: "nam-us-00067-bucks-sec",
  },

  // gift cards
  giftCardConfigs: {
    isMenuGiftCardEnabled: false,
    isLandingPageGiftCardEnabled: false,
    isStandalonePageGiftCardEnabled: false,
    redirectGiftCardUrl: routes.redeem,
  },

  // purchase credit configs
  purchaseCreditConfigs: {
    isLandingPurchaseCreditEnabled: false,
    isStandAlonePurchaseCreditEnabled: false,
    showPurchaseCreditLinkInHomeMenu: false,
    isPurchaseCreditHistoryEnabled: false,
  },

  // disabled routes
  disabledRoutes: [routes.giftCard],

  // switches
  checkoutCreditPackages: false,
  availableCreditEnabled: false,
  isCrowdHandlerEnabled: true,
  inventoryType: inventoryTypeUIDs.seatLevel,

  // purchase seats config
  purchaseSeatConfigs: {
    minGameSelectionCount: 1,
    minSeatLimit: 1,
    isSimilarSeatForAllEvents: true,
    allowManualCartInSimilar: true,
    isCheckoutEditSeatsEnabled: true,
    isDiffSeatAlertEnabled: true,
    defaultSeatCount: 2,
    checkoutTimerEnabled: false,
    isPerksEnabled: false,

    hideViewTicketsInThankYouPage: true,

    isRepProduct: true,
  },

  // feature configs
  packageConfigs: {
    isPackageEnabled: false,
    canRemovePackageGames: false,
    staticBuildYourOwn: null,
  },

  // intercom settings
  intercomConfigs: {
    isIntercomEnabled: true,
    allowedPages: [],
  },

  // checkout validations
  checkoutValidation: {
    allowedZipFailCount: Infinity,
    allowedPaymentFailCount: Infinity,
  },

  // analytics configs
  analyticsConfigs: {
    googleAnalyticsId: "",
    attrkPixelId: "",
    beaconId: "",
  },

  // redirect configs
  redirectConfigs: {
    internalRedirectUrl: "",
    externalRedirectUrl: "",
  },

  refreshInventoryWhenEventClick: false,

  isSaveCardAllowed: true,
  manageCard: true,

  // urls
  accountManagerUrl: "https://am.ticketmaster.com/bucks/",

  // vendor
  platform: vendorUUIDs.ticketmaster,

  // okta config
  oktaIssuer: "",
  oktaClientId: "",

  isBrainTreePaymentEnabled: false,

  // images
  images: {
    logoNameImage: "",
    faviconImage: LogoImage,
    authBackgroundImage: FindGamesBanner.src,
    findGamesBannerImage: FindGamesBanner.src,
    seatMap3dPreviewImage: SeatMap3dPreview.src,
    checkoutStatusPageImage: FindGamesBanner.src,
    logoImage: LogoImage + "?width=128&height=66",
  },

  uiConfigs: {
    bannerImage: {
      title: "",
      isBackgroundBasedBanner: false,
    },

    featuredGameCard: {
      showLogoWithTitle: false,
      hideOverlayLogo: false,
    },

    bottomBar: {
      showGameSelectionProgress: true,
    },

    gameFiltersSettings: {
      hideAccessibilityFilter: false,
      hideSectionFilter: false,
    },

    shouldDisplayServiceFee: false,
    shouldAddServiceFeeWithPerkPrice: true,

    customAdaLabel: (
      <>
        To purchase accessible seating locations, please contact the Box Office
        at{" "}
        <Link
          href="tel:4142270511"
          sx={{
            fontWeight: 500,
            color: "primary.main",
            textDecoration: "none",
          }}
        >
          (414) 227-0511
        </Link>
        .
      </>
    ),
  },

  colors: {
    primary: "#00471B",
  },

  howItWorks: howItWorks,
  faqs: faqs,

  languages: {
    topNavMenuItems: null,
    checkoutTermsAndCondition: <BucksCheckoutTerms />,
    registrationTermsAndCondition: <BucksRegistrationTerms />,
    purchaseSeats: {
      progressBarAditionalText: " to continue!",
      progressBarSuccessText:
        "You're good to go! Add more games or select Continue to view seating options.",
    },
    purchaseGiftCard: null,
    redeemGiftCard: null,

    checkoutSuccessMessage: "Your purchase is complete!",
    checkoutSuccessDescription: "Thank you for your Milwaukee Bucks purchase!",

    giftCard: {
      title: "",
      createGiftCard: {
        description: "",
        recipient: {
          sendNowFalse: {
            description: "",
          },
          sendNowTrue: {
            description: "",
          },
        },
      },
      redeemGiftCard: {
        loggedIn: {
          description: "",
        },
        logout: {
          description: "",
        },
        success: {
          description: "",
        },
      },
    },

    signInAuthText:
      "Connect your Ticketmaster account to continue with seamless access.",
  },
};

export default config;
